module.exports = __webpack_public_path__ + "images/emoji/ambulance.73412b0203625735f8be.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/ambulance.png
// module id = qB1x
// module chunks = 14